<template>
    <div v-auto-animate>
        <div v-if="(originPlaceId && destinationPlaceId) || isClosing">
        <v-btn
            :data-cy="dataCyPrefix ? `${dataCyPrefix}-route-map-button` : 'route-map-button'"
            size="default"
            class="mb-2 mt-2"
            :loading="loading"
            @click.stop="toggle"
        >
            {{ expanded ? $t("entries.hideMap") : $t("entries.getDirections") }}
        </v-btn>
        <v-expand-transition>
            <div v-if="expanded && iframeUrl" class="mt-3">
                <iframe
                    :data-cy="dataCyPrefix ? `${dataCyPrefix}-route-map-iframe` : 'route-map-iframe'"
                    :src="iframeUrl"
                    width="90%"
                    height="350"
                    style="border: 0; border-radius: 8px"
                    allowfullscreen
                    loading="lazy"
                ></iframe>
            </div>
        </v-expand-transition>
        <br />
        </div>
    </div>
</template>

<script>
import { directionsEmbedUrl } from "@/api";
import { showAlertModal } from "@/utils";

export default {
    props: {
        originPlaceId: String,
        destinationPlaceId: String,
        dataCyPrefix: String,
    },
    emits: [],
    data() {
        return {
            expanded: false,
            iframeUrl: null,
            loading: false,
            isClosing: false,
        };
    },
    watch: {
        originPlaceId: "refetchIfExpanded",
        destinationPlaceId: "refetchIfExpanded",
    },
    methods: {
        async toggle() {
            if (this.expanded) {
                this.expanded = false;
                this.iframeUrl = null;
                return;
            }

            this.loading = true;
            try {
                const { url } = await directionsEmbedUrl(
                    this.originPlaceId,
                    this.destinationPlaceId
                );
                this.iframeUrl = url;
                this.expanded = true;
            } catch (e) {
                this.showAlertModal(
                    this.$store,
                    "Failed to load directions",
                    "danger",
                    8000,
                    e
                );
            } finally {
                this.loading = false;
            }
        },
        async refetchIfExpanded() {
            if (
                !this.expanded ||
                !this.originPlaceId ||
                !this.destinationPlaceId
            ) {
                if (!this.originPlaceId || !this.destinationPlaceId) {
                    if (this.expanded) {
                        this.isClosing = true;
                        this.expanded = false;
                        this.iframeUrl = null;
                        setTimeout(() => {
                            this.isClosing = false;
                        }, 420);
                    } else {
                        this.expanded = false;
                        this.iframeUrl = null;
                    }
                }
                return;
            }

            this.loading = true;
            try {
                const { url } = await directionsEmbedUrl(
                    this.originPlaceId,
                    this.destinationPlaceId
                );
                this.iframeUrl = url;
            } catch (e) {
                this.showAlertModal(
                    this.$store,
                    "Failed to load directions",
                    "danger",
                    8000,
                    e
                );
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>